/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './removeOptions.defs.js'
export { main as default } from './removeOptions.defs.js'
